import snakeCase from 'lodash/snakeCase'

export function appendParams(appendHash) {
  const allParams = { ...appendHash }

  let paramsArray = []
  Object.keys(allParams).forEach((key) => {
    if (allParams[key] === null || allParams[key] === undefined) return
    if (Array.isArray(allParams[key])) {
      const arrayToConcat = parseArray(allParams[key], snakeCase(key))
      paramsArray = paramsArray.concat(arrayToConcat)
    } else if (typeof allParams[key] === 'object') {
      const arrayToConcat = parseObject(allParams[key], snakeCase(key))
      paramsArray = paramsArray.concat(arrayToConcat)
    } else {
      const queryKey = snakeCase(key)
      const queryValue = allParams[key]
      return paramsArray.push(`${encodeURIComponent(queryKey)}=${encodeURIComponent(queryValue)}`)
    }
  })
  return `${paramsArray.join('&')}`
}

function parseArray(arr, key) {
  let resultString = []
  arr.forEach((item) => {
    if (typeof item === 'object') {
      resultString = resultString.concat(parseObject(item, `${key}[]`))
    } else {
      const objectString = `${key}[]=${encodeURIComponent(item)}`
      resultString.push(objectString)
    }
  })
  return resultString
}

function parseObject(obj, key) {
  let resultString = []
  Object.keys(obj).forEach((item) => {
    if (Array.isArray(obj[item])) {
      resultString = resultString.concat(parseArray(obj[item], `${key}[${item}]`))
    } else {
      const objectString = `${key}[${item}]=${encodeURIComponent(obj[item])}`
      resultString.push(objectString)
    }
  })
  return resultString
}
